import { Component, computed, OnInit, Signal, Renderer2 } from '@angular/core'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { NaturalStoneCartLine } from '../../../interfaces/natural-stone/natural-stone-cart'
import { NgForOf, NgIf } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { LinkComponent } from '@components/link/link.component'
import { ButtonComponent } from '@components/button/button.component'
import { Router } from '@angular/router'
import { NaturalStoneCartLineComponent } from '../natural-stone-cart-line/natural-stone-cart-line.component'

@Component({
  selector: 'app-natural-stone-mini-cart',
  standalone: true,
    imports: [
        NgForOf,
        TranslateModule,
        LinkComponent,
        NgIf,
        NaturalStoneCartLineComponent,
        ButtonComponent
    ],
  templateUrl: './natural-stone-mini-cart.component.html',
  styleUrl: './natural-stone-mini-cart.component.scss'
})
export class NaturalStoneMiniCartComponent implements OnInit{

    cart: Signal<NaturalStoneCartLine[]>
    isMinicartOpen: Signal<boolean>

    appContainerRef?: HTMLElement | null;

    constructor(
        private naturalStoneService: NaturalStoneService,
        private renderer: Renderer2,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.cart = computed(() => this.naturalStoneService.cart())
        this.isMinicartOpen = computed(() => {
            if(this.naturalStoneService.isMinicartOpen()){
                this.openMinicart(false)
            } else {
                this.closeMinicart(false)
            }
            console.log(this.naturalStoneService.isMinicartOpen())
            return this.naturalStoneService.isMinicartOpen()
        })
        this.appContainerRef = document.getElementsByTagName('app-root')[0].shadowRoot?.getElementById('app-container')
    }

    getTotalInCart(){
        return this.naturalStoneService.getTotalInCart();
    }

    openMinicart(updateState = true) {
        this.renderer.setStyle(this.appContainerRef, 'overflow', 'hidden');
        window.scrollTo(0, 0);
        if(updateState) this.naturalStoneService.isMinicartOpen.set(true)
    }

    closeMinicart(updateState = true) {
        this.renderer.removeStyle(this.appContainerRef, 'overflow');
        if(updateState) this.naturalStoneService.isMinicartOpen.set(false)
    }

    goToFinalizePreorder() {
        this.router.navigate(['natural-stone', 'finalize'])
    }
}
